import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AppStore, TMainSections } from '../../../../state/app.repository';
import { OdinConnectionStatus, OdinService } from '../../../services/odin.service';
import {
  faHouse,
  faSliders,
  faKey,
  faMoonStars,
  faSunBright,
  faRocketLaunch,
} from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslatePipe } from '@ngx-translate/core';
import { RoomInfo } from './room-info/room-info';
import { faInfoCircle } from '@fortawesome/pro-duotone-svg-icons/faInfoCircle';
import { AppConfigStore } from '../../../../state/app-config.repository';
import { AppService } from '../../../services/app.service';
import { UserSettingsStore } from '../../../../state/user-settings.repository';

@Component({
  selector: 'andor-main-nav',
  standalone: true,
  imports: [CommonModule, MatIconModule, FontAwesomeModule, TranslatePipe, RoomInfo],
  templateUrl: './main-nav.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './main-nav.scss',
})
export class MainNav {
  protected readonly faInfoCircle = faInfoCircle;
  faHouse = faHouse;
  faSliders = faSliders;
  faKey = faKey;
  faMoonStars = faMoonStars;
  faSunBright = faSunBright;
  constructor(
    public appStore: AppStore,
    public appConfigStore: AppConfigStore,
    public odinService: OdinService,
    public appService: AppService,
    public userSettingsStore: UserSettingsStore
  ) {}

  onClickedTab(section: TMainSections) {
    this.appStore.update({ activeSection: section });
    if (section === 'about') {
      this.appStore.update({ loginAreaLogoSize: 'invisible' });
    } else {
      this.appStore.update({
        loginAreaLogoSize: this.appService.getResponsiveLogoSize(),
      });
    }
  }

  protected readonly OdinConnectionStatus = OdinConnectionStatus;
  protected readonly faRocketLaunch = faRocketLaunch;
}
